module.exports = __webpack_public_path__ + "media/img/illustrations/s2u-sbt-icon-9a6bb3b613dc5833d14c22899492ee46.svg";